import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {getProductData} from '../../util/getProductData';

@customElement('specsheet-feature')
export class SpecsheetFeature extends connect(store)(LitElement) {

	static styles = css`
	  .row {
		display: flex;
		padding: 0 0 var(--specsheet-feature-padding) 0;
		  justify-content: flex-start;
		  border-bottom: none;
	  }

	  .label {
		display: inline-block;
		font: var(--font-specsheet-bold);
		padding-right: var(--specsheet-feature-padding);
		  white-space: nowrap;
	  }

		:host(.specsheet) .label {
			width: initial;
			min-width: initial;
			padding-right: 5px;
			line-height: 11px;
			font: var(--font-specsheet-bold);
		}
		:host(.specsheet) .value {
			width: initial;
			min-width: initial;
			padding-right: 0;
			line-height: 11px;
			font: var(--font-specsheet-light);
		}


	  @media (min-width: 768px ) {  /*bp-small*/
		.label {
		  min-width: 28%;
		}
	  }

	  .value {
		font: var(--font-specsheet-light);
	  }


	  @media print {
		:host {
		  padding: var(--specsheet-print-feature-padding) 0;
		}
		.row {
			padding: var(--specsheet-print-feature-padding) 0;
		}
		.label {
		  width: 30vw;
		  font: var(--font-specsheet-print-bold);
		  display: initial;
		}
		.line {
		  padding: var(--specsheet-print-feature-padding) 0;
		}
		.value {
		  font: var(--font-specsheet-print-light);
		}
		:host(.specsheet) .row {
			justify-content: flex-start;
			border-bottom: none;
			padding: 0;
		}
		:host(.specsheet) .label {
			width: initial;
			min-width: initial;
			padding-right: 5px;
			line-height: 11px;
			font: var(--font-specsheet-print-bold);
		}
		:host(.specsheet) .value {
			width: initial;
			min-width: initial;
			padding-right: 0;
			line-height: 11px;
			font: var(--font-specsheet-print-light);
		}
	  }


      :host(.white) {
        color: var(--color-white);
        font: var(--font-family-monospace);
      }

		:host(.no-line) .row {
			justify-content: flex-start;
			border-bottom: none;
			padding: 0;
		}
		:host(.no-line) .label {
			width: initial;
			min-width: initial;
			padding-right: 0;
			line-height: 11px;
			font: var(--font-specsheet-print-bold);
		}
		:host(.no-line) .value {
			width: initial;
			min-width: initial;
			padding-right: 0;
			line-height: 11px;
			font: var(--font-specsheet-print-light);
		}


	`;
	@property({type: String})
	key = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.productData = state.productData.productData;
		this.debug = state.status.debug;
		this.styleChoice = this.getAttribute('style-choice') || '';
	}


	static properties = {
		condition: { type: Function },
		styleChoice: { type: String },
	  };

	render() {
		return html`
		${this.condition === undefined || this.condition.trim() !== '' ? html`
			<div class="row ${this.styleChoice}">
				<span class="label">
					<slot name="label">label of feature</slot>
				</span>
				<span class="value">
					<slot name="value">value of feature</slot>
				</span>
			</div>
			` : ''}

		`;
	}
}
